import { Suspense, lazy } from "react";
import { Outlet, useRoutes } from "react-router-dom";

const MainLayout = lazy(() => import("@/components/layout"));

// Pages
const HomePage = lazy(() => import("@/pages/home"));
const AboutPage = lazy(() => import("@/pages/about"));
const HolidaysPage = lazy(() => import("@/pages/holidays"));
const HotelsPage = lazy(() => import("@/pages/hotels"));
const FlightsPage = lazy(() => import("@/pages/flights"));
const ContactPage = lazy(() => import("@/pages/contact"));
const PaymentsPage = lazy(() => import("@/pages/payments"));

// ----------------------------------------------------------------------

export default function AppRouter() {
  const homeRoutes = [
    {
      path: "/",
      element: (
        <MainLayout>
          <Suspense>
            <Outlet />
          </Suspense>
        </MainLayout>
      ),
      children: [
        {
          element: <HomePage />,
          index: true,
        },
        {
          path: "about",
          element: <AboutPage />,
        },
        {
          path: "holidays",
          element: <HolidaysPage />,
        },
        {
          path: "hotels",
          element: <HotelsPage />,
        },
        {
          path: "flights",
          element: <FlightsPage />,
        },
        {
          path: "contact",
          element: <ContactPage />,
        },
        {
          path: "payments",
          element: <PaymentsPage />,
        },
      ],
    },
  ];

  const routes = useRoutes([...homeRoutes]);

  return routes;
}
